import React, { useEffect, useState } from "react";
import { FileText, Building2 } from "lucide-react";
import InvoicesView from "@/components/nds/windows/finance/InvoicesView";
import VendorsView from "@/components/nds/windows/finance/VendorsView";
import FinInvoiceDetail from "@/components/nds/windows/finance/FinInvoiceDetail";
import FinVendorDetail from "@/components/nds/windows/finance/FinVendorDetail";

const VIEWS = [["invoices", "Invoices", FileText], ["vendors", "Vendors", Building2]];

export default function FinInvoicingContent({ win }) {
  const [view, setView] = useState("invoices");
  const [selected, setSelected] = useState(win?.payload?.invoiceId ? { kind: "invoice", id: win.payload.invoiceId } : null);
  useEffect(() => { if (win?.payload?.invoiceId) setSelected({ kind: "invoice", id: win.payload.invoiceId }); }, [win?.payload?.invoiceId, win?.payload?.nonce]);

  if (selected?.kind === "invoice") return <FinInvoiceDetail invoiceId={selected.id} onBack={() => setSelected(null)} />;
  if (selected?.kind === "vendor") return <FinVendorDetail vendorId={selected.id} onBack={() => setSelected(null)} onOpenInvoice={(id) => setSelected({ kind: "invoice", id })} />;
  return (
    <div data-testid="fin-invoicing-content" className="flex flex-col h-full">
      <div className="px-5 pt-3 flex gap-5 border-b border-white/10">
        {VIEWS.map(([id, label, Icon]) => (
          <button key={id} type="button" onClick={() => setView(id)} data-testid={`fin-invoicing-view-${id}`} aria-pressed={view === id}
            className={`pb-2.5 inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase border-b-2 transition-colors ${view === id ? "border-nex-gold text-nex-gold" : "border-transparent text-nex-muted hover:text-nex-silver"}`}>
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>
      {view === "invoices"
        ? <InvoicesView onOpen={(id) => setSelected({ kind: "invoice", id })} />
        : <VendorsView onOpen={(id) => setSelected({ kind: "vendor", id })} />}
    </div>
  );
}
